import ExcelJS from "exceljs";

/**
 * Génère et télécharge le modèle Excel (.xlsx) pour l'import d'écritures comptables.
 */
export const downloadEcrituresExcelTemplate = async () => {
  try {
    const workbook = new ExcelJS.Workbook();
    
    // Feuille 1 : Écritures (Format Sage / SYSCOHADA)
    const ws = workbook.addWorksheet("Écritures (Lignes)");
    
    ws.columns = [
      { header: "JOURNAL", key: "journal", width: 12 },
      { header: "DATE", key: "date", width: 15 },
      { header: "N°PIECE", key: "piece", width: 15 },
      { header: "REFERENCE", key: "reference", width: 25 },
      { header: "COMPTE", key: "compte", width: 16 },
      { header: "TIERS", key: "tiers", width: 18 },
      { header: "LIBELLES", key: "libelle", width: 35 },
      { header: "DEBIT", key: "debit", width: 15 },
      { header: "CREDIT", key: "credit", width: 15 },
    ];

    // Style en-tête
    const headerRow = ws.getRow(1);
    headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
    headerRow.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF0F766E" }, // Teal foncé
    };
    headerRow.alignment = { vertical: "middle", horizontal: "center" };
    headerRow.height = 26;

    // Données d'exemples équilibrées
    const sampleRows = [
      {
        journal: "CAI",
        date: "2026-07-03",
        piece: "CAI01001",
        reference: "ALIMENTATION GLE",
        compte: "401000",
        tiers: "FALIMENTATION",
        libelle: "RGT ACHAT DE RIZ & HUILE",
        debit: 33000,
        credit: null,
      },
      {
        journal: "CAI",
        date: "2026-07-03",
        piece: "CAI01001",
        reference: "ALIMENTATION GLE",
        compte: "571000",
        tiers: "",
        libelle: "RGT ACHAT DE RIZ & HUILE",
        debit: null,
        credit: 33000,
      },
      {
        journal: "BQ",
        date: "2026-07-05",
        piece: "BQ0001",
        reference: "FA002537",
        compte: "606100",
        tiers: "FDIVERS",
        libelle: "FOURNITURES DE BUREAU",
        debit: 150000,
        credit: null,
      },
      {
        journal: "BQ",
        date: "2026-07-05",
        piece: "BQ0001",
        reference: "FA002537",
        compte: "521100",
        tiers: "",
        libelle: "PAIEMENT FOURNITURES",
        debit: null,
        credit: 150000,
      },
      {
        journal: "SALAIRES",
        date: "2026-07-30",
        piece: "SAL0701",
        reference: "PAIE JUILLET",
        compte: "661100",
        tiers: "",
        libelle: "SALAIRES BRUTS",
        debit: 500000,
        credit: null,
      },
      {
        journal: "SALAIRES",
        date: "2026-07-30",
        piece: "SAL0701",
        reference: "PAIE JUILLET",
        compte: "421100",
        tiers: "PERS01",
        libelle: "NET A PAYER",
        debit: null,
        credit: 400000,
      },
      {
        journal: "SALAIRES",
        date: "2026-07-30",
        piece: "SAL0701",
        reference: "PAIE JUILLET",
        compte: "431300",
        tiers: "IPRES",
        libelle: "COTISATIONS SOCIALES",
        debit: null,
        credit: 100000,
      },
    ];

    sampleRows.forEach((row) => {
      ws.addRow(row);
    });

    // Feuille 2 : Instructions & Codes Journaux
    const wsHelp = workbook.addWorksheet("Instructions & Journaux");
    wsHelp.columns = [
      { header: "Élément", key: "k", width: 25 },
      { header: "Description & Valeurs acceptées", key: "v", width: 65 },
    ];
    const hHelp = wsHelp.getRow(1);
    hHelp.font = { bold: true, color: { argb: "FFFFFFFF" } };
    hHelp.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF334155" } };

    wsHelp.addRows([
      { k: "JOURNAL", v: "CAI (Caisse), BQ (Banque), ACH (Achats), VT/VTE (Ventes), SAL (Salaires), FISC (Fiscalité), OD (Opérations Diverses)" },
      { k: "DATE", v: "Format AAAA-MM-JJ ou JJ/MM/AAAA (ex: 2026-07-03)" },
      { k: "N°PIECE", v: "Identifiant unique reliant les lignes d'une même écriture (ex: CAI01001)" },
      { k: "COMPTE", v: "Numéro de compte SYSCOHADA (ex: 401000, 521100, 606100...). Toutes les classes (1 à 7) sont acceptées." },
      { k: "ÉQUILIBRE", v: "Pour un même N° de pièce, la somme des débits doit être égale à la somme des crédits." },
    ]);

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "modele_import_ecritures_easycompta.xlsx";
    link.click();
  } catch (error) {
    console.error("Erreur génération template Excel :", error);
  }
};

/**
 * Télécharge un modèle CSV prêt à l'emploi.
 */
export const downloadEcrituresCsvTemplate = () => {
  const csvContent =
    "JOURNAL,DATE,N°PIECE,REFERENCE,COMPTE,TIERS,LIBELLES,DEBIT,CREDIT\n" +
    "CAI,2026-07-03,CAI01001,ALIMENTATION GLE,401000,FALIMENTATION,RGT ACHAT DE RIZ & HUILE,33000,\n" +
    "CAI,2026-07-03,CAI01001,ALIMENTATION GLE,571000,,RGT ACHAT DE RIZ & HUILE,,33000\n" +
    "BQ,2026-07-05,BQ0001,FA002537,606100,FDIVERS,FOURNITURES DE BUREAU,150000,\n" +
    "BQ,2026-07-05,BQ0001,FA002537,521100,,PAIEMENT FOURNITURES,,150000\n" +
    "SALAIRES,2026-07-30,SAL0701,PAIE JUILLET,661100,,SALAIRES BRUTS,500000,\n" +
    "SALAIRES,2026-07-30,SAL0701,PAIE JUILLET,421100,PERS01,NET A PAYER,,400000\n" +
    "SALAIRES,2026-07-30,SAL0701,PAIE JUILLET,431300,IPRES,COTISATIONS SOCIALES,,100000\n";

  const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "modele_import_ecritures_easycompta.csv";
  link.click();
};
